import GET_ARTICLES from "../plugins/getArticles";
import magnificPopup from "magnific-popup"

// import 'slick-carousel'
export default function HOME() {

  $(() => {
  
    // トップページカスタム
    $.topInit();
  
    // ブロック整形
    (function(__){ $.each(__, $.topBlockCustomizer) }({
      'news':{
        button:{
          disp: true,
          text: 'MORE',
          attr: {
            class: 'button button-grey c-btn-icon-right button-large notranslate'
          }
        },
        title:{
          html: '<span class="notranslate">新着情報</span><small class="notranslate">News</small>' // プレーンテキストで動的にする場合は false
        },
        itemlayout: function($this,$catetitle,$date,$new,$title){
          $this
          .append( $date )
          .append( $catetitle )
          .append( $title.append($new) )
        }
      }
    }));

    GET_ARTICLES('.p-block-goods',{
      makeItem(item,opt,type="media"){
        const $link = $(`
          <a href="${item.href}" class="${opt.prefix}${type}">
            <div class="${opt.prefix}${type}-img">
              <div class="${opt.prefix}${type}-img__inner" style="background-image:url('${item.thumb}')"><img src="${item.thumb}" alt="${item.title}" /></div>
            </div>
            <div class="${opt.prefix}${type}-body">
              <h4 class="${opt.prefix}${type}-title notranslate">${item.title}</h4>
            </div>
          </a>
        `)
        const $catlink = $(`<a href="${item.category.href}" class="${opt.prefix}${type}-category notranslate">${item.category.name}</a>`)
        $link.find(`.${opt.prefix}${type}-body`).prepend( $catlink )
        return $link[0]
      }
    })

    // FacebookSDK
    $.ajaxSetup({ cache: false });
    $.getScript('//connect.facebook.net/ja_JP/sdk.js', () => {
      const FB = window.FB||{}
      FB.init({
        appId: '759600244139396',
        xfbml: true,
        version: 'v2.8'
      });
    });

    // popup
    window.load['block-social'].done(()=>{
      if(!$.UA.is_mobile){
        const $popup = $('[data-plugin="popup"]')
        $popup.each((i,v) => $(v).magnificPopup( $.extend(true,{zoom:{enabled:true}},v.dataset) ))
      }
    })
    

  });

}